<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div class="body_main">
<!--        <div class="breadcrumb_bd">-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item to="/admin/home" @click="changeData('home')">工作台</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item to="/admin/order" @click="changeData('order')">订单管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>订单详情</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </div>-->

        <div class="body_bd" style="background: #f5f7fa">
            <Orderdetail :orderId="detailOrderId"></Orderdetail>
        </div>
    </div>
</template>

<script>

import Orderdetail from "@/components/orderdetail.vue";

export default {
    components: {
        Orderdetail
    },
    props: {
        orderId: null
    },
    data() {
        return {
            detailOrderId: null
        }
    },
    created() {
        this.detailOrderId = this.$route.query.orderId;
        console.log("this.detailOrderId");
        console.log(this.detailOrderId);
    },
    methods: {
        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
        },

    }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/style.scss";
</style>